import { render } from "./GeoPointIcon.vue?vue&type=template&id=c3033b18"
import script from "./GeoPointIcon.vue?vue&type=script&lang=js"
export * from "./GeoPointIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__